import React from 'react';
import {
  Text,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from '@chakra-ui/react';

interface FgtPwModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}

export const DeleteModal = ({ isOpen, onClose }: FgtPwModalProps) => {
  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        h="296px"
        minW={{ base: '80%', md: '548px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        <ModalHeader
          p="0px"
          fontSize="xl"
          fontWeight={800}
          color="black"
          alignSelf="center"
        >
          Gostaria de realmente apagar o registro?
        </ModalHeader>
        <ModalCloseButton borderRadius="36px" color="black" />

        <ModalBody py="0px " px="0px" textAlign="center">
          <Text p="8px 0 0px 0" fontSize="sm" color="grey.600">
            Após apagar o registro não será possível recuperar os dados
          </Text>
        </ModalBody>

        <ModalFooter pb="0px">
          <Button variant="outline" onClick={onClose}>
            Voltar
          </Button>
          <Button ml="16px" onClick={onClose}>
            Apagar registro
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
